import { Component } from 'react';
import { connect } from 'react-redux';
import CarouselItem from './carousel-item';
import CarouselRender from './carousel-render';

import './style.css';

class EverythingElseCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolled: false,
      data: []
    };
  }

  renderItems = () => {
    const { isScrolled } = this.state;

    this.setState({
      data: this.props.latestNews.map((article, index) => (
        <CarouselItem
          key={index}
          image={article.attributes.link.image}
          id={article.id}
          name={article.attributes.title}
          isScrolled={isScrolled}
        />
      ))
    });
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.latestNews !== this.props.latestNews &&
      Array.isArray(this.props.latestNews) &&
      !!this.props.latestNews.length) {
      this.renderItems();
    }
  }

  componentDidMount = () => {
    this.renderItems();
  }

  handleOnClick = () => {
    const { isScrolled } = this.state;

    this.setState({ isScrolled: !isScrolled }, () => {
      this.renderItems();
    });
  }

  render() {
    const { loading } = this.props;
    const { data } = this.state;

    return (
      <CarouselRender
        loading={loading}
        data={data}
        title='Everything Else'
        onClick={this.handleOnClick}
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.latestNews.fetching,
  latestNews: state.latestNews.latestNews.filter(article => (
    article.attributes.category.name === 'EVERYTHING ELSE'
  ))
});

export default connect(mapStateToProps)(EverythingElseCarousel);
